import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 12.444v5.778c0 .982-.796 1.778-1.778 1.778h-5.778a.444.444 0 0 1 0-.889h5.778c.491 0 .89-.398.89-.889v-5.778a.444.444 0 0 1 .888 0zM14.217 10.416a.445.445 0 1 1-.63-.63L18.49 4.89h-2.862a.437.437 0 0 1-.436-.445c0-.242.194-.44.436-.444h3.94a.432.432 0 0 1 .433.436v3.94a.438.438 0 0 1-.444.436.444.444 0 0 1-.445-.435v-2.86l-4.894 4.899zM9.787 13.587a.445.445 0 1 1 .629.63L5.517 19.11h2.86a.437.437 0 0 1 .435.444c0 .242-.193.44-.435.445H4.436a.431.431 0 0 1-.307-.127.444.444 0 0 1-.129-.306v-3.94a.437.437 0 0 1 .444-.436c.242 0 .44.193.445.435v2.863l4.898-4.902zM4 11.556V5.778C4 4.796 4.796 4 5.778 4h5.778a.444.444 0 0 1 0 .889H5.778a.889.889 0 0 0-.89.889v5.778a.444.444 0 0 1-.888 0z"
});

var SvgExpand = function SvgExpand(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgExpand;